<template>
  <div class="container">
    <v-scroll-x-transition group>
      <v-alert
        v-for="alert in toastAlerts"
        :key="alert.id"
        class="mb-2"
        :closable="alert.dismissable"
        :text="alert.message"
        :type="alert.type"
      />
    </v-scroll-x-transition>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  dismissable?: boolean
  dismissAfter?: number
}>();

const toastAlerts = computed<ToastAlert[]>(() => useToastAlerts().alerts);
</script>

<style scoped>
.container {
  position: fixed;
  user-select: none;
  bottom: 0;
  right: 1rem;
  width: 400px;
  background: transparent;
  opacity: 0.9;
  pointer-events: none;
  z-index: 2500;  /* Higher than the Vuetify dialogs */
}

.v-alert {
  pointer-events: all;
  user-select: all;
}
</style>
